import {Component, OnInit, inject} from '@angular/core';
import {DataService} from "../../../services/data.service";
import {RouterLink} from '@angular/router';
import {PaginationModule} from 'ngx-bootstrap/pagination';
import {FormsModule} from '@angular/forms';
import {NgIf, NgFor} from '@angular/common';

@Component({
    selector: 'app-region-list',
    templateUrl: './region-list.component.html',
    styleUrl: './region-list.component.scss',
    imports: [RouterLink, PaginationModule, FormsModule, NgIf, NgFor]
})
export class RegionListComponent implements OnInit {

    private dataService = inject(DataService);

    paginConfig: any;
    entries: any[];
    totalEntries = 0;
    predicate = 'region';
    reverse = false;

    ngOnInit(): void {
        this.paginConfig = {
            itemsPerPage: 25,
            page: 1
        };
        this.listEntries(this.paginConfig);
    }

    setOrder(order): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event): void {
        this.paginConfig = event;

        this.entries = null;
        this.dataService.request('Region/listAll', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate,
            reverse: this.reverse,
        }).subscribe(response => {
            this.totalEntries = response.total;
            this.entries = response.regions;
        });
    }

}
